import React from 'react';
import isEmpty from 'lodash/isEmpty';
import SVGIcon from '../../../../../assets/images/svg/SVGIcon';
import { Header, LeftHeader, Title, RightHeader, Plus, DropDiv, DragHandle } from './styles';
import { AssignGroup1, AvatarImage } from '../styles';
import CircularProgress from '../../../../../component/circularProgress';
import Avatar from '../../../../../component/avatar';
import IconButton from '../../../../../component/button/iconButton';
import { Dropdown } from '../../../../../component/dropdown';
import { ICON_BUTTON_SIZE, ICON_BUTTON_TYPE, ICON_SIZE, AVATAR_BORDER } from '../../../../../global/constants';
import { useMobileDevice } from '../../../../../global/useMobile';
import { Milestone } from '../../../../../mobx/interfaces/project';
import type { DraggableAttributes } from '@dnd-kit/core';
import { useSortable } from '@dnd-kit/sortable';

type SortableListeners = ReturnType<typeof useSortable>['listeners'];

interface Props {
  item: Milestone;
  isMilestoneItem: boolean;
  menuEditItemsMapped: React.ReactNode;
  menuRestoreItemsMapped: React.ReactNode;
  isSortableItem?: boolean;
  sortableAttributes?: DraggableAttributes;
  sortableListeners?: SortableListeners;
}

const MilestoneHeader: React.FC<Props> = ({
  item,
  isMilestoneItem,
  menuEditItemsMapped,
  menuRestoreItemsMapped,
  isSortableItem,
  sortableAttributes,
  sortableListeners
}) => {
  const mobile = useMobileDevice();

  return (
    <>
      <DragHandle
        role='button'
        onClick={(e) => e.stopPropagation()}
        isSortable={Boolean(isMilestoneItem && isSortableItem)}
        {...(isMilestoneItem && isSortableItem ? sortableListeners : {})}>
        <SVGIcon
          className='dotted-icon'
          name='new-three-dots-vertical-icon'
          width={ICON_SIZE.SM}
          height={ICON_SIZE.SM}
          viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
        />
      </DragHandle>

      <Header>
        <LeftHeader>
          <CircularProgress
            progressPercentage={Number(item?.progressData?.progress)}
            status={item?.progressData?.status}
          />
          <Title>{item?.milestoneName}</Title>
        </LeftHeader>

        <RightHeader>
          <AssignGroup1>
            <ul>
              {item?.users
                ?.filter((item) => !isEmpty(item?.id))
                ?.map((userProfile, indexUser) => {
                  if (indexUser > 2 && mobile) return null;
                  return (
                    <li key={userProfile?.id}>
                      <AvatarImage>
                        <Avatar
                          size={20}
                          imgSrc={userProfile?.profile_photo || ''}
                          name={userProfile?.name}
                          borderVariant={AVATAR_BORDER.THIN}
                        />
                      </AvatarImage>
                    </li>
                  );
                })}

              {item?.users?.length > 3 && mobile && (
                <li className='plus-icon'>
                  <Plus>+{item?.users?.length - 3}</Plus>
                </li>
              )}
            </ul>
          </AssignGroup1>

          <DropDiv>
            <Dropdown
              modalTitle='Manage Milestone'
              activeClassName='active-state'
              content={
                <IconButton
                  iconName='new-three-dots-vertical-icon'
                  size={ICON_BUTTON_SIZE.SMALL}
                  variant={ICON_BUTTON_TYPE.TERTIARY}
                />
              }
              trigger='click'>
              {isMilestoneItem ? menuEditItemsMapped : menuRestoreItemsMapped}
            </Dropdown>
          </DropDiv>
        </RightHeader>
      </Header>
    </>
  );
};

export default MilestoneHeader;
